/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A ModelSerializer that takes an additional `fields` argument that
 * controls which fields should be displayed.
 * @export
 * @interface RasterOptions
 */
export interface RasterOptions {
  /**
   *
   */
  demFile?: string;
  /**
   *
   */
  demRawFile?: string;
  /**
   *
   */
  equilibriumInfiltrationRateFile?: string;
  /**
   *
   */
  frictCoefFile?: string;
  /**
   *
   */
  initialGroundwaterLevelFile?: string;
  /**
   *
   */
  initialWaterlevelFile?: string;
  /**
   *
   */
  groundwaterHydroConnectivityFile?: string;
  /**
   *
   */
  groundwaterImperviousLayerLevelFile?: string;
  /**
   *
   */
  infiltrationDecayPeriodFile?: string;
  /**
   *
   */
  initialInfiltrationRateFile?: string;
  /**
   *
   */
  leakageFile?: string;
  /**
   *
   */
  phreaticStorageCapacityFile?: string;
  /**
   *
   */
  hydraulicConductivityFile?: string;
  /**
   *
   */
  porosityFile?: string;
  /**
   *
   */
  infiltrationRateFile?: string;
  /**
   *
   */
  maxInfiltrationCapacityFile?: string;
  /**
   *
   */
  interceptionFile?: string;
  /**
   *
   */
  vegetationHeightFile?: string;
  /**
   *
   */
  vegetationDragCoefficientFile?: string;
  /**
   *
   */
  vegetationStemCountFile?: string;
  /**
   *
   */
  vegetationStemDiameterFile?: string;
  /**
   *
   */
  initialConcentrationFile?: string;
  /**
   *
   */
  initialGroundwaterConcentrationFile?: string;
}

/**
 * Check if a given object implements the RasterOptions interface.
 */
export function instanceOfRasterOptions(value: object): value is RasterOptions {
  return true;
}

export function RasterOptionsFromJSON(json: any): RasterOptions {
  return RasterOptionsFromJSONTyped(json, false);
}

export function RasterOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RasterOptions {
  if (json == null) {
    return json;
  }
  return {
    demFile: json["dem_file"] == null ? undefined : json["dem_file"],
    demRawFile: json["dem_raw_file"] == null ? undefined : json["dem_raw_file"],
    equilibriumInfiltrationRateFile:
      json["equilibrium_infiltration_rate_file"] == null
        ? undefined
        : json["equilibrium_infiltration_rate_file"],
    frictCoefFile: json["frict_coef_file"] == null ? undefined : json["frict_coef_file"],
    initialGroundwaterLevelFile:
      json["initial_groundwater_level_file"] == null
        ? undefined
        : json["initial_groundwater_level_file"],
    initialWaterlevelFile:
      json["initial_waterlevel_file"] == null ? undefined : json["initial_waterlevel_file"],
    groundwaterHydroConnectivityFile:
      json["groundwater_hydro_connectivity_file"] == null
        ? undefined
        : json["groundwater_hydro_connectivity_file"],
    groundwaterImperviousLayerLevelFile:
      json["groundwater_impervious_layer_level_file"] == null
        ? undefined
        : json["groundwater_impervious_layer_level_file"],
    infiltrationDecayPeriodFile:
      json["infiltration_decay_period_file"] == null
        ? undefined
        : json["infiltration_decay_period_file"],
    initialInfiltrationRateFile:
      json["initial_infiltration_rate_file"] == null
        ? undefined
        : json["initial_infiltration_rate_file"],
    leakageFile: json["leakage_file"] == null ? undefined : json["leakage_file"],
    phreaticStorageCapacityFile:
      json["phreatic_storage_capacity_file"] == null
        ? undefined
        : json["phreatic_storage_capacity_file"],
    hydraulicConductivityFile:
      json["hydraulic_conductivity_file"] == null ? undefined : json["hydraulic_conductivity_file"],
    porosityFile: json["porosity_file"] == null ? undefined : json["porosity_file"],
    infiltrationRateFile:
      json["infiltration_rate_file"] == null ? undefined : json["infiltration_rate_file"],
    maxInfiltrationCapacityFile:
      json["max_infiltration_capacity_file"] == null
        ? undefined
        : json["max_infiltration_capacity_file"],
    interceptionFile: json["interception_file"] == null ? undefined : json["interception_file"],
    vegetationHeightFile:
      json["vegetation_height_file"] == null ? undefined : json["vegetation_height_file"],
    vegetationDragCoefficientFile:
      json["vegetation_drag_coefficient_file"] == null
        ? undefined
        : json["vegetation_drag_coefficient_file"],
    vegetationStemCountFile:
      json["vegetation_stem_count_file"] == null ? undefined : json["vegetation_stem_count_file"],
    vegetationStemDiameterFile:
      json["vegetation_stem_diameter_file"] == null
        ? undefined
        : json["vegetation_stem_diameter_file"],
    initialConcentrationFile:
      json["initial_concentration_file"] == null ? undefined : json["initial_concentration_file"],
    initialGroundwaterConcentrationFile:
      json["initial_groundwater_concentration_file"] == null
        ? undefined
        : json["initial_groundwater_concentration_file"],
  };
}

export function RasterOptionsToJSON(json: any): RasterOptions {
  return RasterOptionsToJSONTyped(json, false);
}

export function RasterOptionsToJSONTyped(
  value?: RasterOptions | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dem_file: value["demFile"],
    dem_raw_file: value["demRawFile"],
    equilibrium_infiltration_rate_file: value["equilibriumInfiltrationRateFile"],
    frict_coef_file: value["frictCoefFile"],
    initial_groundwater_level_file: value["initialGroundwaterLevelFile"],
    initial_waterlevel_file: value["initialWaterlevelFile"],
    groundwater_hydro_connectivity_file: value["groundwaterHydroConnectivityFile"],
    groundwater_impervious_layer_level_file: value["groundwaterImperviousLayerLevelFile"],
    infiltration_decay_period_file: value["infiltrationDecayPeriodFile"],
    initial_infiltration_rate_file: value["initialInfiltrationRateFile"],
    leakage_file: value["leakageFile"],
    phreatic_storage_capacity_file: value["phreaticStorageCapacityFile"],
    hydraulic_conductivity_file: value["hydraulicConductivityFile"],
    porosity_file: value["porosityFile"],
    infiltration_rate_file: value["infiltrationRateFile"],
    max_infiltration_capacity_file: value["maxInfiltrationCapacityFile"],
    interception_file: value["interceptionFile"],
    vegetation_height_file: value["vegetationHeightFile"],
    vegetation_drag_coefficient_file: value["vegetationDragCoefficientFile"],
    vegetation_stem_count_file: value["vegetationStemCountFile"],
    vegetation_stem_diameter_file: value["vegetationStemDiameterFile"],
    initial_concentration_file: value["initialConcentrationFile"],
    initial_groundwater_concentration_file: value["initialGroundwaterConcentrationFile"],
  };
}
